import React, { FC, Ref } from 'react';

import './Select.css';
import clsx from 'clsx';

import { ChevronDownIcon } from '../../assets/svg/ChevronDownIcon';

export type OptionType = {
	value: string;
	label: string;
	disabled?: boolean;
	order?: number;
};

export type SelectProps = {
	acceptanceTestTargetId?: string;
	options?: OptionType[];
	className?: string;
	invalid?: boolean;
	ref?: Ref<HTMLSelectElement>;
} & React.InputHTMLAttributes<HTMLSelectElement>;

export const Select: FC<SelectProps> = ({ options, className, invalid, acceptanceTestTargetId, ref, ...rest }) => (
	<div className={clsx('select-container', className)}>
		<select
			ref={ref}
			{...rest}
			className={clsx('select-dropdown', invalid && 'select-dropdown-invalid')}
			data-field-invalid={invalid ? true : null}
			data-pp-at-target={acceptanceTestTargetId}
		>
			{(options || []).map(option => (
				<option key={option.value} disabled={option.disabled} value={option.value}>
					{option.label}
				</option>
			))}
		</select>
		<div className="select-icon-wrapper">
			<ChevronDownIcon className="select-icon" width="15" />
		</div>
	</div>
);
